import { FC } from "react";
import Layout from "components/Layout";
import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import DataTable from "components/DataTable";
import CrudLayout from "components/CrudLayout";
import {
  // IconButton,
  Spinner,
  Stack,
  Switch,
  useDisclosure,
} from "@chakra-ui/react";
import { doc, getDoc } from "firebase/firestore";
import ActionsButton from "components/ActionsButton";
import FormUser from "components/FormUser";
import SearchInput from "components/SearchInput";
// import { FaSync } from "react-icons/fa";
import { IUser } from "interfaces/user";
import useUser from "hooks/useUser";
import { useDeleteDialog } from "hooks";
import ConfirmDialog from "components/ConfirmDialog";
import useDoorLock from "hooks/useDoorLock";
import { db } from "connections/firebase";
import { IHouse } from "interfaces/house";

const Users: FC = () => {
  const { data, loading, loadingAction, deleteUser, updateStatusUser } =
    useUser();
  const { grantLock } = useDoorLock();
  const { isOpen, onClose } = useDisclosure();
  const { isOpenDelete, deleteId, onOpendelete, onCloseDelete } =
    useDeleteDialog();
  const path = "/users";

  const columnHelper = createColumnHelper<IUser>();

  const remove = (id: string) => {
    onOpendelete(id);
  };

  const edit = (id: string) => {
    console.log("edit");
  };

  const columns: ColumnDef<IUser, any>[] = [
    columnHelper.accessor("name", {
      cell: (info) => info.getValue(),
      header: "Nama",
    }),
    columnHelper.accessor("email", {
      cell: (info) => info.getValue(),
      header: "Email",
    }),
    columnHelper.accessor("houseId", {
      cell: (info) => info.getValue().map((value: any) => ` ${value.blok}`),
      header: "Rumah",
    }),
    columnHelper.accessor("status", {
      cell: (info) => (
        <>
          {info.row.getValue("id") === loadingAction ? (
            <Spinner />
          ) : (
            <Switch
              onChange={async (e) => {
                await updateStatusUser(
                  info.row.getValue("id"),
                  e.target.checked
                );
                if (data && e.target.checked) {
                  await Promise.all(
                    data[info.row.index].houseId.map(async (item) => {
                      const house = await getDoc(doc(db, "houses", item.id));
                      if (house.exists()) {
                        const houseData = house.data() as IHouse;
                        await Promise.all(
                          houseData.devices.map(async (device) => {
                            if (
                              device.type === "lock" &&
                              "lockId" in device.config
                            ) {
                              const lockId = parseInt(device.config.lockId);
                              const result = await grantLock({
                                lockId,
                                userId: data[info.row.index].id,
                              });
                              console.log(result);
                            }
                          })
                        );
                      }
                    })
                  );
                }
              }}
              defaultChecked={info.getValue()}
            />
          )}
        </>
      ),
      header: "Status",
    }),
    columnHelper.accessor("id", {
      header: () => null,
      cell: (info) => (
        <ActionsButton
          id={info.getValue()}
          actions={[
            {
              label: "Lihat Detail",
              onClick: edit,
            },
            { label: "Hapus", onClick: remove },
          ]}
        />
      ),
      meta: {
        sx: {
          textAlign: "right",
        },
      },
      enableGlobalFilter: false,
      enableSorting: false,
    }),
  ];

  return (
    <Layout isPrivate>
      <CrudLayout breadcrumb={[{ title: "Users", link: path }]}>
        <Stack direction="row" alignItems="center" mb={8}>
          <SearchInput
            onSearch={(search) => {
              // getBranch({ search: search });
              console.log("search", search);
            }}
          />
        </Stack>
        {data && (
          <DataTable isLoading={loading} columns={columns} data={data} />
        )}
      </CrudLayout>
      <FormUser isOpen={isOpen} onClose={onClose} />
      <ConfirmDialog
        loading={loadingAction !== null}
        isOpen={isOpenDelete}
        onClose={onCloseDelete}
        onConfirm={async () => {
          await deleteUser(deleteId);
        }}
      />
    </Layout>
  );
};

export default Users;
